<template>
  <div class="role-page">
    <a-card>
      <div class="role-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="role-title-bar">
            <a-button type="primary">+ 新增角色</a-button>
            <a-input placeholder="请输入角色名称查询" style="width:220px;margin-left:16px;" />
            <a-button type="primary" style="margin-left:8px;">查询</a-button>
          </div>
          <div class="role-main">
            <!-- 左侧角色列表 -->
            <div class="role-list-panel">
              <div class="role-list-title">角色列表</div>
              <div class="role-list-content">
                <a-list :data-source="roleList" :pagination="false" style="background:#fff;">
                  <template #renderItem="{ item }">
                    <a-list-item 
                      :class="{selected: item.selected}" 
                      @click="selectRole(item)"
                      style="padding: 12px 16px; cursor: pointer; border-left: 2px solid transparent;"
                    >
                      {{ item.name }}
                    </a-list-item>
                  </template>
                </a-list>
              </div>
              <div class="role-list-pagination">
                <a-pagination :total="2" :pageSize="1" :current="1" size="small" />
              </div>
            </div>
            <!-- 右侧tab及详情 -->
            <div class="role-detail-panel">
              <a-tabs v-model:activeKey="tabKey" class="role-tabs-full">
                <a-tab-pane key="info" tab="角色信息">
                  <a-table :columns="columns" :data-source="roleInfoData" :pagination="false" size="middle" bordered>
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'action'">
                        <a-button type="default" size="small" style="margin-right:8px;">编辑角色信息</a-button>
                        <a-button type="danger" size="small">删除角色</a-button>
                      </template>
                    </template>
                  </a-table>
                </a-tab-pane>
                <a-tab-pane key="perm" tab="权限授权">
                  <div class="permission-panel">
                    <!-- 左侧授权分组 -->
                    <div class="permission-groups">
                      <div class="group-title">授权分组</div>
                      <a-list :data-source="permGroups" :pagination="false" size="small">
                        <template #renderItem="{ item }">
                          <a-list-item 
                            :class="{active: item.code === activeGroup}" 
                            @click="handleGroupSelect(item.code)"
                            style="padding: 8px 16px; cursor: pointer;"
                          >
                            {{ item.name }}
                          </a-list-item>
                        </template>
                      </a-list>
                    </div>
                    <!-- 右侧权限表格 -->
                    <div class="permission-table">
                      <a-table
                        :columns="permColumns"
                        :data-source="permissionList"
                        :pagination="false"
                        size="middle"
                        :row-selection="{ selectedRowKeys: selectedPerms, onChange: onPermChange }"
                      >
                        <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'status'">
                            <a-tag v-if="record.status === '默认开通'" color="blue">默认开通</a-tag>
                            <a-button v-else type="primary" size="small" ghost>申请权限</a-button>
                          </template>
                        </template>
                      </a-table>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane key="app" tab="应用授权">
                  <div style="height:80px;"></div>
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

interface PermissionGroup {
  name: string
  code: string
  children?: Permission[]
}

interface Permission {
  name: string
  code: string
  description?: string
  status?: string
}

const permissionList = ref([
  {
    name: '基础',
    code: 'group1',
    children: [
      { name: '通知配置', code: 'group1', status: '默认开通' },
      { name: '查询通知配置', code: 'systemNotifyConfigFind', status: '申请权限' },
      { name: '删除通知配置', code: 'systemNotifyConfigDelete', status: '申请权限' },
      { name: '修改通知配置', code: 'systemNotifyConfigModify', status: '申请权限' },
      { name: '新增通知配置', code: 'systemNotifyConfigAdd', status: '申请权限' }
    ]
  },
  {
    name: '运营管理',
    code: 'group2',
    children: [
      { name: '运营管理', code: 'group2', status: '默认开通' },
      { name: '新增工单管理', code: 'systemOpsWorkOrderAdd', status: '默认开通' },
      { name: '修改帮助与反馈', code: 'systemOpsFeedbackModify', status: '默认开通' },
      { name: '查询帮助与反馈', code: 'systemOpsFeedbackFind', status: '默认开通' },
      { name: '修改工单管理', code: 'systemOpsWorkOrderModify', status: '申请权限' }
    ]
  }
])
const tabKey = ref('info')
const roleList = ref([
  { name: '普通用户', selected: true },
  { name: '超级管理员', selected: false }
])
function selectRole(item: any) {
  roleList.value.forEach(r => (r.selected = false))
  item.selected = true
}
const columns = [
  { title: '角色名称', dataIndex: 'name', key: 'name' },
  { title: '管理员', dataIndex: 'admin', key: 'admin' },
  { title: '角色编码', dataIndex: 'code', key: 'code' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
const roleInfoData = [
  { name: '管理员', admin: 'admin', code: 'admin', createdAt: '2025-05-02 11:33' }
]
const activeGroup = ref('group1')
const selectedPerms = ref<string[]>([])
const permGroups = ref([
  { name: '基础', code: 'group1' },
  { name: '运营管理', code: 'group2' }
])

const permColumns = [
  { title: '权限名称', dataIndex: 'name', key: 'name' },
  { title: '权限编码', dataIndex: 'code', key: 'code' },
  { title: '操作', key: 'status' }
]

function handleGroupSelect(code: string) {
  activeGroup.value = code
}

function onPermChange(selectedRowKeys: string[]) {
  selectedPerms.value = selectedRowKeys
}
</script>

<style lang="less" scoped>
.role-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .role-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .role-title-bar {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }
      .role-main {
        display: flex;
        height: calc(100vh - 180px);
        min-height: 400px;
        .role-list-panel {
          width: 180px;
          background: #fff;
          border-radius: 4px;
          margin-right: 16px;
          display: flex;
          flex-direction: column;
          .role-list-title {
            font-weight: bold;
            margin-bottom: 8px;
          }
          .role-list-content {
            flex: 1;
            overflow-y: auto;
          }
          .role-list-pagination {
            margin-top: 8px;
            text-align: center;
          }
          .selected {
            background: #fff;
            color: #1677ff;
            border-left-color: #1677ff !important;
          }
        }
        .role-detail-panel {
          flex: 1;
          background: #fff;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          min-width: 0;
          .role-tabs-full {
            flex: 1;
            display: flex;
            flex-direction: column;
            .ant-tabs-content-holder {
              flex: 1;
              display: flex;
              flex-direction: column;
            }
            .ant-tabs-tabpane {
              flex: 1;
              display: flex;
              flex-direction: column;
            }
          }
        }
      }
    }
  }
}
.permission-list {
  padding: 16px;
  .permission-group {
    margin-bottom: 24px;
    .permission-group-title {
      font-weight: bold;
      margin-bottom: 16px;
    }
    .permission-items {
      .permission-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        .permission-item-code {
          color: #666;
          margin-left: 32px;
          flex: 1;
        }
        .permission-item-status {
          width: 80px;
          text-align: right;
        }
      }
    }
  }
}
.permission-panel {
  display: flex;
  height: 100%;
  
  .permission-groups {
    width: 200px;
    border-right: 1px solid #f0f0f0;
    padding: 16px 0;
    
    .group-title {
      padding: 0 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }
    
    .active {
      color: #1677ff;
      background: #e6f7ff;
    }
  }
  
  .permission-table {
    flex: 1;
    padding: 16px;
    overflow: auto;
  }
}
</style>